import type { AppModule } from "../types";
import { s } from "./strings";

export const clientsTagsModule: AppModule = {
  name: "clients-tags",
  routes: {
    shell: [
      {
        path: "/clients",
        handle: { title: s.clientsTitle },
        lazy: () => import("./pages/ClientsPage").then((m) => ({ Component: m.ClientsPage })),
      },
      {
        path: "/tags",
        handle: { title: s.tagsTitle },
        lazy: () => import("./pages/TagsPage").then((m) => ({ Component: m.TagsPage })),
      },
    ],
  },
  // Owner/Admin only (spec 6.1); the shell owns placement after TEAM under MANAGE.
  sidebar: [
    {
      id: "CLIENTS",
      label: "Clients",
      path: "/clients",
      icon: "clients",
      alt: "View Clients",
      visible: (c) => c.isAdmin,
    },
    { id: "TAGS", label: "Tags", path: "/tags", icon: "tag", alt: "View tags", visible: (c) => c.isAdmin },
  ],
};
